import { EPermissoes } from '@/enums/ePermissoes';
import cadastro from './cadastro/routes';
import relatorios from './relatorios/routes';

const withTipoFornecimento = (routes: any[], utlTipoFornecimentoId: number): any[] =>
  routes.map((route) => ({
    ...route,
    meta: {
      ...route.meta,
      utlTipoFornecimentoId
    },
    children: route.children ? withTipoFornecimento(route.children, utlTipoFornecimentoId) : route.children
  }));

const routes = [
  {
    description: '4. Laudo de Graute',
    path: 'laudo',
    name: 'laudoGraute',
    component: () => import('@/views/controle-tecnologico/laudo/Index.vue'),
    goesToMenu: true,
    meta: {
      tipoFornecimento: 'Graute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Laudo de Graute',
    path: 'laudo/incluir/:tipoEnsaioId/:laboratorioId',
    name: 'laudoinsertGraute',
    component: () => import('@/views/controle-tecnologico/laudo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'laudoGraute',
      utlTipoFornecimentoId: 4,
      laudoOpcional: false,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: []
    }
  },
  {
    description: 'Edição de Laudo de Graute',
    path: 'laudo/editar/:id/:tipoEnsaioId/:laboratorioId',
    name: 'laudoUpdateGraute',
    component: () => import('@/views/controle-tecnologico/laudo/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'laudoGraute',
      utlTipoFornecimentoId: 4,
      laudoOpcional: false,
      permissions: [EPermissoes.Lancamento_Laudo],
      grupos: []
    }
  },
  {
    description: 'Revisão de Laudo de Graute',
    path: 'revisao-laudo',
    name: 'revisaolaudoGraute',
    component: () => import('@/views/controle-tecnologico/aprovacao-laudo/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.Aprovacao_Laudo],
      grupos: [],
      escopoObra: 'obra'
    }
  },
  {
    description: '1. Recebimento de Graute',
    path: 'recebimento',
    name: 'recebimentograute',
    component: () => import('@/views/concreto/recebimento-graute-argamassa/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 4,
      tipoConcreto: 4,
      permissions: [EPermissoes.Lancamento_Recebimento],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Recebimento de Graute',
    path: 'recebimento/incluir',
    name: 'recebimentograuteinsert',
    component: () => import('@/views/concreto/recebimento-graute-argamassa/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'recebimentograute',
      utlTipoFornecimentoId: 4,
      tipoConcreto: 4,
      permissions: [EPermissoes.Lancamento_Recebimento]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Recebimento de Graute',
    path: 'recebimento/editar/:id',
    name: 'recebimentograuteupdate',
    component: () => import('@/views/concreto/recebimento-graute-argamassa/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'recebimentograute',
      utlTipoFornecimentoId: 4,
      tipoConcreto: 4,
      permissions: [EPermissoes.Lancamento_Recebimento]
    },
    goesToMenu: false
  },
  {
    description: '2. Aplicação de Graute',
    path: 'aplicacao',
    name: 'aplicacaograute',
    component: () => import('@/views/utilidade/aplicacao-ambiente/Index.vue'),
    meta: {
      tipoFornecimento: 'graute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.Lancamento_Aplicacao],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Aplicação de Graute',
    path: 'aplicacao/incluir',
    name: 'inclusaoaplicacaograute',
    component: () => import('@/views/utilidade/aplicacao-ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'aplicacaograute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.Lancamento_Aplicacao]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Aplicação de Graute',
    path: 'aplicacao/editar/:protocolo',
    name: 'aplicacaograuteupdate',
    component: () => import('@/views/utilidade/aplicacao-ambiente/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'aplicacaograute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.Lancamento_Aplicacao]
    },
    goesToMenu: false
  },
  {
    description: '3. Ensaio de Graute',
    path: 'ensaio',
    name: 'ensaiograute',
    component: () => import('@/views/utilidade/ensaio/Index.vue'),
    goesToMenu: true,
    meta: {
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.Lancamento_ResultadoEnsaios],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão/Edição de Ensaio de Graute',
    path: 'ensaio/incluir',
    name: 'InclusaoEdicaoEnsaioGraute',
    component: () => import('@/views/utilidade/ensaio/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: {
      parentRouteName: 'ensaiograute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.Lancamento_ResultadoEnsaios]
    }
  },
  {
    description: 'Lote de Graute',
    path: 'lote',
    name: 'produtofornecedorlotegraute',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/Index.vue'),
    meta: {
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.Lancamento],
      escopoObra: 'obra'
    },
    goesToMenu: true
  },
  {
    description: 'Inclusão de Lote de Graute',
    path: 'lote/incluir?produto=:utlProdutoId&fornecedor=:gesFornecedorId',
    name: 'produtofornecedorlotegrauteinsert',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'produtofornecedorlotegraute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.Lancamento]
    },
    goesToMenu: false
  },
  {
    description: 'Edição de Lote de Graute',
    path: 'lote/editar/:id?produto=:utlProdutoId&fornecedor=:gesFornecedorId',
    name: 'produtofornecedorlotegrauteupdate',
    component: () => import('@/views/utilidade/produto-fornecedor-lote/InclusaoEdicao.vue'),
    meta: {
      parentRouteName: 'produtofornecedorlotegraute',
      utlTipoFornecimentoId: 4,
      permissions: [EPermissoes.Lancamento]
    },
    goesToMenu: false
  },
  {
    description: '5. Traço Experimental',
    path: 'traco-experimental',
    name: 'tracoExperimentalGraute',
    component: () => import('@/views/concreto/traco-experimental/Index.vue'),
    goesToMenu: true,
    meta: {
      tipoConcreto: 4,
      permissions: [EPermissoes.Lancamento_Recebimento],
      escopoObra: 'obra'
    }
  },
  {
    description: 'Inclusão de Traço Experimental de Graute',
    path: 'traco-experimental/incluir',
    name: 'tracoExperimentalGrauteinsert',
    component: () => import('@/views/concreto/traco-experimental/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: { parentRouteName: 'tracoExperimentalGraute', tipoConcreto: 4, permissions: [EPermissoes.Lancamento_Recebimento] }
  },
  {
    description: 'Edição de Traço Experimental de Graute',
    path: 'traco-experimental/editar/:id',
    name: 'tracoExperimentalGrauteupdate',
    component: () => import('@/views/concreto/traco-experimental/InclusaoEdicao.vue'),
    goesToMenu: false,
    meta: { parentRouteName: 'tracoExperimentalGraute', tipoConcreto: 4, permissions: [EPermissoes.Lancamento_Recebimento] }
  },
  {
    path: 'cadastro',
    description: 'Cadastro',
    goesToMenu: false,
    children: cadastro
  },
  {
    path: 'relatorios',
    description: 'Relatórios',
    goesToMenu: false,
    children: relatorios
  }
];

export default [
  {
    path: 'graute',
    description: 'Graute',
    meta: {
      utlTipoFornecimentoId: 4
    },
    goesToMenu: false,
    children: withTipoFornecimento(routes, 4)
  }
];
